export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/ac478f259eebce517c6cc06e4306b00d.svg";